import React from "react";
import { Flame } from "lucide-react";

// Severity → Aurora token mapping (logic preserved, points at design tokens)
const SEV_COLORS = {
  CRITICAL: "var(--au-error)",
  HIGH: "var(--au-error)",
  MEDIUM: "var(--au-warn)",
  LOW: "var(--au-accent-ink)",
  NONE: "var(--au-muted)",
  UNKNOWN: "var(--au-muted)"
};

export default function CVECard({ data }) {
  if (!data || !data.cves || data.cves.length === 0) return null;

  return (
    <div className="au-glass au-pad" style={{ marginBottom: 20 }}>
      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "center", marginBottom: 18,
        paddingBottom: 14, borderBottom: "1px solid var(--au-hair)"
      }}>
        <div className="au-eyebrow" style={{
          display: "inline-flex", alignItems: "center", gap: 8, color: "var(--au-error)"
        }}>
          <Flame size={14} aria-hidden="true" /> KNOWN VULNERABILITIES
        </div>
        <span className="au-chip au-chip-status" style={{ color: "var(--au-error)" }}>
          {data.count} CVE{data.count !== 1 ? "s" : ""} found
        </span>
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {data.cves.map((cve, i) => {
          const sev = (cve.severity || "UNKNOWN").toUpperCase();
          const color = SEV_COLORS[sev] || "var(--au-muted)";
          return (
            <div key={i} style={{
              background: "var(--au-glass)",
              border: "1px solid var(--au-hair)",
              borderLeft: `3px solid ${color}`,
              borderRadius: "var(--au-r-sm)",
              padding: "12px 16px"
            }}>
              <div style={{
                display: "flex", justifyContent: "space-between",
                alignItems: "center", marginBottom: 6, flexWrap: "wrap", gap: 8
              }}>
                <span className="au-mono" style={{
                  color: "var(--au-accent-ink)",
                  fontSize: 13, fontWeight: 700
                }}>{cve.id}</span>
                <div style={{ display: "flex", gap: 6 }}>
                  <span className="au-chip au-chip-status" style={{ color }}>
                    <span className="au-led" style={{ background: color, boxShadow: `0 0 6px ${color}` }} />
                    {sev}
                  </span>
                  {cve.cvss_score !== null && cve.cvss_score !== undefined && (
                    <span className="au-chip au-chip-status au-mono" style={{ color: "var(--au-text)" }}>
                      CVSS {cve.cvss_score}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ fontSize: 11, color: "var(--au-muted)", marginBottom: 6 }}>
                Matched: <span style={{ color: "var(--au-accent-ink)" }}>{cve.matched_tech}</span>
                {cve.published && (<span> · Published {cve.published}</span>)}
              </div>
              <div style={{ fontSize: 12, color: "var(--au-text-2)", lineHeight: 1.5 }}>
                {cve.description}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ fontSize: 10, color: "var(--au-muted)", marginTop: 14, textAlign: "right" }}>
        Cross-referenced with global vulnerability intelligence
      </div>
    </div>
  );
}
